import { useState, useEffect } from 'react';

// Module-level cache — persists across component mounts/unmounts
// so navigating between pages doesn't re-fetch
let cachedProducts = null;
let fetchPromise = null;

const useProductsData = () => {
  const [products, setProducts] = useState(cachedProducts || []);
  const [loading, setLoading] = useState(!cachedProducts);
  const [error, setError] = useState(null);

  useEffect(() => {
    // If already cached, no need to fetch
    if (cachedProducts) {
      setProducts(cachedProducts);
      setLoading(false);
      return;
    }

    // If a fetch is already in-flight (another component triggered it), reuse it
    if (!fetchPromise) {
      fetchPromise = fetch(`${import.meta.env.BASE_URL}data/products.json`)
        .then(res => {
          if (!res.ok) throw new Error(`Failed to fetch products: ${res.status}`);
          return res.json();
        })
        .then(data => {
          const items = data.products || data;
          cachedProducts = items;
          return items;
        })
        .catch(err => {
          fetchPromise = null; // Allow retry on error
          throw err;
        });
    }

    fetchPromise
      .then(items => {
        setProducts(items);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return { products, loading, error };
};

export default useProductsData;
